import { createApiClient } from '@enderrealm/api-sdk';
import type { ApiClient } from '@enderrealm/api-sdk';
import { useMemo } from 'react';
import { useEnvironment } from '@/components/Environment/EnvironmentContext';

export type EnderRealmClient = ApiClient;

/** 用指定的 baseUrl + apiKey 构建 SDK 客户端 */
export function buildClient(baseUrl: string, apiKey: string): EnderRealmClient | null {
  if (!baseUrl) return null;
  return createApiClient({ baseUrl, apiKey });
}

/** 绑定「当前环境」的客户端，环境切换时自动重建 */
export function useEnderRealmClient(): EnderRealmClient | null {
  const { activeEnvironment, apiKeys } = useEnvironment();
  return useMemo(() => {
    if (!activeEnvironment) return null;
    return buildClient(activeEnvironment.baseUrl, apiKeys[activeEnvironment.id] ?? '');
  }, [activeEnvironment, apiKeys]);
}

/** 从 SDK 的 { data, error } 中提取可读的错误文案 */
export function getErrorDetail(error: unknown): string {
  if (typeof error === 'object' && error !== null) {
    const record = error as Record<string, unknown>;
    if (typeof record.detail === 'string' && record.detail) return record.detail;
    if (record.status !== undefined) return `HTTP ${String(record.status)}`;
  }
  return error instanceof Error ? error.message : String(error);
}